import { useMemo, useEffect } from 'react'

import { getSortedOrdersByDeparture } from 'selectors/orderSelectors'
import { isOrderCancelled, haveOrdersBeenFetched, isStandaloneMerchandiseOrder } from 'lib/order/orderUtils'
import { useAppDispatch, useAppSelector } from './reduxHooks'
import { fetchOrders } from 'actions/OrderActions'

type ClassifiedOrders = { cancelled: Array<App.Order>, purchased: Array<App.Order> }

export function useMerchandiseOrdersByStatus() {
  const dispatch = useAppDispatch()
  const { data: allSortedOrders } = useAppSelector(getSortedOrdersByDeparture)
  const ordersFetched = useAppSelector((state) => haveOrdersBeenFetched(state, 'upcoming'))
  const loading = !ordersFetched

  useEffect(() => {
    if (!ordersFetched) {
      dispatch(fetchOrders())
    }
  }, [dispatch, ordersFetched])

  const merchandiseOrders = useMemo(() =>
    allSortedOrders.filter(order => order.merchandiseItems.length > 0),
  [allSortedOrders])

  const { purchased, cancelled } = useMemo(() =>
    merchandiseOrders.reduce<ClassifiedOrders>((acc, order) => {
      if (isOrderCancelled(order)) {
        if (order.customOfferItems.length > 0) {
          return acc
        }

        acc.cancelled.push(order)
        return acc
      }

      acc.purchased.push(order)

      return acc
    }, { cancelled: [], purchased: [] }),
  [merchandiseOrders])

  const hasTravelOrders = merchandiseOrders.some(order => !isStandaloneMerchandiseOrder(order))

  return { loading, purchased, cancelled, hasTravelOrders }
}
